<template>
  <div>
    <div class="info-key">{{ $t("message.precinctsReporting") }}:</div>
    <div class="info-value ml-1">{{ precinctsReporting.perc }}%</div>
  </div>
</template>

<script>
const props = {
  precinctsReporting: {
    type: Object,
    required: true,
  },
};

export default {
  props,
};
</script>
